import { Controller } from "@hotwired/stimulus";

/**
 * Выдвижное меню на узком экране.
 *
 * Панель — нативный `<dialog>`: top layer, Esc и ловушка фокуса достаются
 * даром. Раньше это был div с классом `open`, свой оверлей и глобальная
 * функция `toggleMenu` из inline-onclick.
 */
export default class extends Controller {
  static targets = ["panel"];
  // Смахивание вправо шире этого расстояния закрывает меню.
  static SWIPE = 50;

  toggle() {
    if (this.panelTarget.open) this.close();
    else this.panelTarget.showModal();
  }

  close() {
    this.panelTarget.close();
  }

  touchStart(event) {
    this.startX = event.changedTouches[0].screenX;
  }

  /** Смахивание вправо — привычный жест закрытия боковой панели. */
  touchEnd(event) {
    if (event.changedTouches[0].screenX - this.startX > this.constructor.SWIPE) {
      this.close();
    }
  }
}
